import script from "./ReadModelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadModelCard.vue?vue&type=script&setup=true&lang=js"

import "./ReadModelCard.vue?vue&type=style&index=0&id=4946314e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4946314e"]])

export default __exports__